import React, { useState, useEffect, Fragment } from 'react';
import {
  Widget,
  ButtonCancel,
  FormSubmitButton,
  FormatText,
  FormInput,
  Button,
  FormDatePicker,
  FormSelect,
  MasterDetailForm,
  Row,
  Col,
  FormNumber,
} from '@digital/ui';
import { getAllPerfilMrnOptions, getAllPerfilFornecedorOptions, PerfilAcessoResult } from '@app/api/PerfilAcesso';
import { updateUsuario, changePassword, ativarUsuario, inativarUsuario, approveChanges, MostrarDiretoriaAreaDepartamento, getContratosAcessiveis, saveContratosBloqueados, ContratoAcessivel } from '@app/api/usuario';
import * as Yup from 'yup';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import CreatCartaNomeacao from '../Usuario/CreatCartaNomeacao';
import { VerificarSeUsuarioLogadoAdministradorDoContatoSessaoNumeroContrato } from '@app/api/contrato';
import { ETipoUsuario } from '@app/enums/ETipoUsuario';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import TipoOptions from '@app/helpers/tipoOptions';

const idPerfilAdmistacaoDiretoriaAreDepartamento = [
  '1899f2b8-dc67-4862-8029-48deb4b1fcbe',
  '44cb31e9-9e5b-4fdc-87ae-6165ff332cbc',
  '2ce0c239-2950-4f46-8ddb-f311cd0b3501'];

const PerfilForm = (props:
  {
    selectedItem: any;
    onUpdate: Function,
    diretoriaOptions: TipoOptions[] | undefined,
    areasOptions: TipoOptions[] | undefined,
    departamentoOptions: TipoOptions[] | undefined,
  }
) => {

  const {
    onUpdate,
    selectedItem,
    diretoriaOptions,
    areasOptions,
    departamentoOptions
  } = props;




  const [mostrarDiretoriaAreaDepartamento, setMostrarDiretoriaAreaDepartamento] = useState<MostrarDiretoriaAreaDepartamento>({
    diretoria: false,
    area: false,
    departamento: false,
  } as MostrarDiretoriaAreaDepartamento);



  const [trocarSenha, setTrocarSenha] = useState(false);
  const [atualizarGridAnexo, setAtualizarGridAnexo] = useState(false);
  const [PerfilOptions, setPerfilOptions] = useState();
  const [usuarioLogadoEAdmContrato, setUsuarioLogadoEAdmContrato] = useState(false);
  const [perfisUsuario, setPerfisUsuario] = useState<string[]>(['']);
  const [contratosAcessiveis, setContratosAcessiveis] = useState<ContratoAcessivel[]>([]);
  const [contratosBloqueadosSelecionados, setContratosBloqueadosSelecionados] = useState<string[]>([]);
  const submitDadosUsuario = (values: any) => {
    values.perfis = perfisUsuario;
    return updateUsuario(values).then(() => {
      onUpdate();
      setAtualizarGridAnexo(!atualizarGridAnexo);
    });
  };

  const handleChangePassword = (values: any) =>
    changePassword(selectedItem.id, values).then(resp => {
      if (resp.valid) {
        handleTrocarSenha();
        onUpdate();
      }
    });
  const handleAtivarUsuario = () => ativarUsuario(selectedItem.id).then(resp => onUpdate());
  const handleInativarUsuario = () => inativarUsuario(selectedItem.id).then(resp => onUpdate());
  const handleApproveChanges = () => approveChanges(selectedItem.id).then(resp => onUpdate());

  useEffect(() => {
    setTrocarSenha(false);
    (props.selectedItem && props.selectedItem.tipoUsuarioCodigo == 1) || props.selectedItem.tipoUsuarioCodigo == 3
      ? setPerfilOptions(getAllPerfilMrnOptions)
      : setPerfilOptions(getAllPerfilFornecedorOptions);
  }, [props.selectedItem]);

  useEffect(() => {
    if (selectedItem && selectedItem.tipoUsuarioCodigo == 1) {
      VerificarSeUsuarioLogadoAdministradorDoContatoSessaoNumeroContrato(selectedItem.contrato).then(data =>
        setUsuarioLogadoEAdmContrato(data),
      );
    }
    if (selectedItem) {
      setPerfisUsuario(selectedItem.perfis);
    }

    // Carregar contratos acessíveis se o usuário logado for administrador de contrato
    if (selectedItem && selectedItem.id && hasPermissionPerfil([EGuidPerfilAcesso.AdministradorContratoMRN])) {
      getContratosAcessiveis(selectedItem.id).then(data => {
        if (data) {
          setContratosAcessiveis(data);
          const bloqueados = data.filter(c => c.estaBloqueado).map(c => c.id);
          setContratosBloqueadosSelecionados(bloqueados);
        }
      });
    }
  }, [props.selectedItem]);

  useEffect(() => {
    if (perfisUsuario) {
      let mostrarDiretoria = false;
      let mostrarArea = false;
      let mostrarDepartamento = false;

      if (perfisUsuario.includes(idPerfilAdmistacaoDiretoriaAreDepartamento[0])) {
        mostrarDiretoria = true;
      }

      if (perfisUsuario.includes(idPerfilAdmistacaoDiretoriaAreDepartamento[1])) {
        mostrarArea = true;
      }

      if (perfisUsuario.includes(idPerfilAdmistacaoDiretoriaAreDepartamento[2])) {
        mostrarDepartamento = true;
      }

      setMostrarDiretoriaAreaDepartamento({
        ...mostrarDiretoriaAreaDepartamento,
        area: mostrarArea,
        diretoria: mostrarDiretoria,
        departamento: mostrarDepartamento,
      });
    }
  }, [perfisUsuario]);

  const handleTrocarSenha = () => {
    setTrocarSenha(!trocarSenha);
  };

  const emptyElement = <span />;

  const UsuarioPodeTrocarUsername = hasPermission(['USUARIO_ALTERAR_USERNAME_SAS_FORNECEDOR'])  && props.selectedItem.tipoUsuarioCodigo == ETipoUsuario.FornecedorSas;

   return (
    <>
      {trocarSenha ? (
        <MasterDetailForm
          onSubmit={handleChangePassword}
          validationSchema={Yup.object().shape({
            oldPassword: Yup.string()
              .required('A Senha atual deve ser informada.')
              .max(50, 'A senha deve ter no máximo 50 caracteres.'),
            newPassword: Yup.string()
              .required('A nova senha deve ser informada.')
              .max(50, 'A nova senha deve ter no máximo 50 caracteres.'),
            confirmNewPassword: Yup.string()
              .required('A confirmação de senha deve ser informada.')
              .max(50, 'A confirmação de senha deve ter no máximo 50 caracteres.')
              .oneOf([Yup.ref('newPassword'), null], 'A confirmação de senha e a nova senha devem ser iguais.'),
          })}>
          <Widget
            title="Troca de Senha"
            actions={[
              <ButtonCancel type="link" onClick={handleTrocarSenha} />,
              <FormSubmitButton noIcon={true} type="primary">
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <Row>
              <FormInput label="Senha Atual" name="oldPassword" type="password" span={4} required />
            </Row>
            <Row>
              <FormInput label="Nova Senha" name="newPassword" type="password" span={4} required />
            </Row>
            <Row>
              <FormInput label="Confirmação" name="confirmNewPassword" type="password" span={4} required />
            </Row>
          </Widget>
        </MasterDetailForm>
      ) : (
        <MasterDetailForm onSubmit={submitDadosUsuario} initialValues={selectedItem}>
          <Widget
            title="Dados de Usuário"
            actions={[
           
              <Button type="link" onClick={handleTrocarSenha}>
                Trocar Senha
              </Button>,
              props.selectedItem &&
                props.selectedItem.status == 'Pendente' &&
                (usuarioLogadoEAdmContrato == true || hasPermission(['USUARIO_ATIVAR_INATIVAR'])) ? (
                <>
                  <Button type="link" icon="ui-checkmark" onClick={handleApproveChanges}>
                    Confirmar Alterações
                  </Button>
                </>
              ) : (
                <Fragment />
              ),

              hasPermission(['USUARIO_ATIVAR_INATIVAR']) ? (
                props.selectedItem && props.selectedItem.status == 'Ativo' ? (
                  <>
                    <Button type="danger" onClick={handleInativarUsuario}>
                      Inativar
                    </Button>
                  </>
                ) : (
                  <>
                    <Button type="success" onClick={handleAtivarUsuario}>
                      Ativar
                    </Button>
                  </>
                )
              ) : (
                <Fragment />
              ),

              <FormSubmitButton noIcon={true} type="primary">
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            {props.selectedItem &&
              props.selectedItem.tipoUsuarioCodigo != 1 &&
              props.selectedItem.tipoUsuarioCodigo != 3 ? (
              <FormInput label="Contrato" name="contrato" disabled span={6} />
            ) : (
              emptyElement
            )}
            {props.selectedItem &&
              props.selectedItem.tipoUsuarioCodigo != 1 &&
              props.selectedItem.tipoUsuarioCodigo != 3 ? (
              <FormInput label="Fornecedor" name="fornecedor" disabled span={6} />
            ) : (
              emptyElement
            )}
            <FormInput label="Username" name="username" disabled={!UsuarioPodeTrocarUsername} span={6} />
            <FormDatePicker
              format="DD/MM/YYYY"
              label="Data do último Acesso"
              name="dataHoraUltimaAcesso"
              disabled
              span={6}
            />
            <FormInput disabled={props.selectedItem.tipoUsuarioCodigo == 1} label="Nome" name="nome" span={6} />
            <FormInput disabled={props.selectedItem.tipoUsuarioCodigo == 1} label="E-mail" name="email" span={6} />
            <FormInput disabled={props.selectedItem.tipoUsuarioCodigo == 1} label="Cargo" name="cargo" span={6} />
            <FormInput
              disabled={props.selectedItem.tipoUsuarioCodigo == 1}
              label="Telefone 1"
              name="telefone1"
              span={3}
            />
            <FormInput label="Telefone 2" name="telefone2" span={3} />
            <fieldset>
              <legend>Tipos de Usuários</legend>
              {(props.selectedItem &&
                (props.selectedItem.tipoUsuarioCodigo == ETipoUsuario.MRN ||
                  props.selectedItem.tipoUsuarioCodigo == ETipoUsuario.Terceiro)) ||
                hasPermissionPerfil([EGuidPerfilAcesso.GerenteGPC, EGuidPerfilAcesso.AdministradorGPC]) ||
                hasPermission(['USUARIO_ALTERAR_IDENTIFICADOR_ERP']) ? (
                <FormInput
                  label="Identificador ERP"
                  name="identificadorErp"
                  disabled={
                    selectedItem.tipoUsuarioCodigo !== ETipoUsuario.Terceiro.toString() ||
                    !hasPermissionPerfil([EGuidPerfilAcesso.GerenteGPC, EGuidPerfilAcesso.AdministradorGPC])
                  }
                  span={6}
                />
              ) : (
                emptyElement
              )}
              <FormInput label="Tipo de Usuário" name="tipoUsuario" disabled span={6} />
            </fieldset>

            {perfisUsuario && perfisUsuario.includes('15b4e007-b1fe-4d52-972c-6d0558b5551c') && (
              <fieldset>
                <legend>Pré-Contratação</legend>
                <FormNumber label="Nº processos paralelos" name="processosParalelos" span={6} />
              </fieldset>
            )}
            <fieldset>
              <legend>Perfil</legend>
              <FormSelect
                disabled={props.selectedItem.tipoUsuarioCodigo != 1 && props.selectedItem.tipoUsuarioCodigo != 3}
                mode="multiple"
                label="Perfis"
                name="perfis"
                options={PerfilOptions}
                span={12}
                showSearch
                optionFilterProp="children"
                filterOption={(input, item) => {
                  return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                }}
                onChange={e => setPerfisUsuario(e)}
              />
            </fieldset>


            {props.selectedItem.tipoUsuarioCodigo != 2 && mostrarDiretoriaAreaDepartamento ?
              (
                <fieldset>
                  <legend>Administração</legend>

                  {mostrarDiretoriaAreaDepartamento.diretoria ? (
                    <>
                      <FormSelect
                        mode="multiple"
                        label="Administração Diretoria"
                        name="administracaoDiretoria"
                        options={diretoriaOptions}
                        span={12}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                          return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                        }}
                        onChange={e => { }}
                      />

                    </>) : (<> </>)}

                  {mostrarDiretoriaAreaDepartamento.area ? (
                    <>
                      <FormSelect
                        mode="multiple"
                        label="Administração Área"
                        name="administracaoArea"
                        options={areasOptions}
                        span={12}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                          return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                        }}
                        onChange={e => { }}
                      />

                    </>) : (<> </>)}

                  {mostrarDiretoriaAreaDepartamento.departamento ? (
                    <>
                      <FormSelect
                        mode="multiple"
                        label="Administração Departamento"
                        name="administracaoDepartamento"
                        options={departamentoOptions}
                        span={12}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                          return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                        }}
                        onChange={e => { }}
                      />

                    </>) : (<> </>)}

                  {hasPermissionPerfil([EGuidPerfilAcesso.AdministradorContratoMRN]) && selectedItem && selectedItem.id ? (
                    <>
                      <FormSelect
                        mode="multiple"
                        label="Contratos Bloqueados"
                        name="contratosBloqueados"
                        options={contratosAcessiveis.map(c => ({
                          text: `${c.numero} - ${c.fornecedor || ''}`,
                          value: c.id
                        }))}
                        value={contratosBloqueadosSelecionados}
                        span={12}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                          return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                        }}
                        onChange={async (e) => {
                          setContratosBloqueadosSelecionados(e);
                          if (selectedItem && selectedItem.id) {
                            await saveContratosBloqueados(selectedItem.id, e);
                          }
                        }}
                      />
                    </>) : (<> </>)}
                </fieldset>
              )
              :
              (
                <>
                
                </>
              )
            }


            {selectedItem && selectedItem.id ? (
              <>
                <CreatCartaNomeacao usuarioId={selectedItem.id} atualizarInformacoes={atualizarGridAnexo} />{' '}
              </>
            ) : (
              <> </>
            )}
          </Widget>
        </MasterDetailForm>
      )
      }
    </>
  );
};

export default PerfilForm;
